import userQueries from '@apis/queries/userQueries';
import Loading from '@components/Loading';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { useQueryClient } from '@tanstack/react-query';
import { setIsPrepaidCardBalanceUpdated } from '@utils/prepaidCardUtils';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

interface Params {
    cardId: string;
}

declare module '@stackflow/config' {
    interface Register {
        PrepaidCardChargeCompleteActivity: Params;
    }
}

// 외부 결제 페이지에서 처음 진입하므로 스택을 메인 → 내 선불카드로 다시 쌓는다.
const PrepaidCardChargeCompleteActivity: ActivityComponentType<'PrepaidCardChargeCompleteActivity'> = () => {
    const { t } = useTranslation('prepaidCard');
    const { replace, push } = useFlow();
    const queryClient = useQueryClient();
    useEffect(() => {
        if (import.meta.env.MODE !== 'development') {
            console.log('prepaid charge complete');
        }
        queryClient.invalidateQueries({ queryKey: userQueries.assets().queryKey });
        toast.success(t('chargeComplete.success'));
        setIsPrepaidCardBalanceUpdated(true);
        replace('MainActivity', {}, { animate: false });
        push('MyPrepaidCardActivity', {});
    }, []);
    return (
        <AppScreen>
            <Loading />
        </AppScreen>
    );
};

export default PrepaidCardChargeCompleteActivity;
